export const getSelectedVariantTitle = (selectedVariant) => {
    if (!selectedVariant || !selectedVariant.title || selectedVariant.title === 'Default Title') return '';

    return selectedVariant.title;
};
